// src/config/terms.js
//
// One source of truth for the Terms version and company contact details.
//
// TERMS_VERSION is the important one. Acceptance records store the version a
// person agreed to, so "did this customer accept the no-refunds clause?" has a
// checkable answer rather than an assumption. Bump it whenever the Terms
// change materially — anyone whose stored version is older is re-prompted at
// their next sign-in or payment.
//
// IMPORTANT: functions/stripeSubscriptions.js has its own TERMS_VERSION
// constant. They must be kept in step. It is duplicated rather than imported
// because the functions bundle doesn't share this module.

export const TERMS_VERSION = "2026-08-23";
export const TERMS_EFFECTIVE_DATE = "August 23, 2026";
export const PRIVACY_VERSION = "2026-08-23";

export const COMPANY = {
  legalName: "Smart Board Learning, LLC",
  shortName: "Smart Board Learning",
  productName: "Smart Board Learning",
  website: "smartboardlearning.com",
  address: "P.O. Box 22, Ashburn, VA 20146, USA",
  email: "team@smartboardlearning.com",
  phone: "(571) 563-6142",
  phoneHref: "5715636142",
};

export default { TERMS_VERSION, TERMS_EFFECTIVE_DATE, PRIVACY_VERSION, COMPANY };
